// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"f4fc07ed","841":"6f92562f"}[chunkId] + ".chunk.css";
};